import { type FC } from 'react';
import styled from 'styled-components';

import { useOrganizationName } from '@/api/organizations/hooks/useOrganizationName';
import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import coverImage from '@/assets/images/rob1179-5642.jpg';
import { Column, Row } from '@/components/Grid';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { prettifyOrganizationName } from '@/util/prettifyOrganizationName';

import { A4WidthForPrint } from '../components/A4WidthForPrint';
import { StyledStorebrandLogo } from '../components/StyledStorebrandLogo';
import { usePresentationContext } from '../PresentationContext';

export const CoverScreen: FC = () => {
  const texts = useTexts();
  const organizationCmId = useOrganizationCmId();
  const { organizationName } = useOrganizationName(organizationCmId);

  const { globalFilter } = usePresentationContext();

  return (
    <A4WidthForPrint>
      <Row>
        <LeftColumn $span={5}>
          <WithGap gap="96">
            <WithGap>
              <h1>{prettifyOrganizationName(organizationName)}</h1>
              <WithGap gap="8">
                {globalFilter.portfolioGroups.map((portfolioGroup) => (
                  <div className="font-body-large" key={portfolioGroup.id}>
                    {texts.pages.presentation.screens.cover.portfolio}{' '}
                    {portfolioGroup.id} - {portfolioGroup.name}
                  </div>
                ))}
              </WithGap>
            </WithGap>
            <LogoWrapper>
              <StyledStorebrandLogo />
            </LogoWrapper>
          </WithGap>
        </LeftColumn>
        <RightColumn $span={7}>
          <div>
            <Image src={coverImage} />
          </div>
        </RightColumn>
      </Row>
    </A4WidthForPrint>
  );
};

const LogoWrapper = styled.div`
  height: 24px;
`;

const LeftColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const RightColumn = styled(Column)`
  display: flex;
  justify-content: end;
`;

const Image = styled.img`
  max-width: 100%;
  // Allows the image to be resized, but keep the same square aspect ratio.
  aspect-ratio: 1/1;
  object-fit: cover;
  object-position: center;
`;
